import { createAction } from '@reduxjs/toolkit';

export const featureUpdateId = createAction('feature/updateId');
export const featureUpdateUID = createAction('feature/updateUid');
export const featureUpdateSID = createAction('feature/updateSid');
export const featureUpdateIsAdded = createAction('feature/updateIsAdded');
export const featureUpdateIsActive = createAction('feature/updateIsActive');

export const featureStore = createAction('feature/store');
export const featureClear = createAction('feature/clear');

export const featureUpdateRequesting = createAction('feature/updateRequesting');
export const featureUpdateRequest = createAction('feature/updateRequest');
export const featureUpdateError = createAction('feature/updateError');
export const featureUpdateStore = createAction('feature/updateStore');

export const featureUpdateItems = createAction('feature/updateItems');
export const featureUpdateAlign = createAction('feature/updateAlign');
export const featureUpdateBackgroundColor = createAction('feature/updateBackgroundColor');
export const featureUpdateTextColor = createAction('feature/updateTextColor');
export const featureUpdateImageSize = createAction('feature/updateImageSize');
export const featureUpdateImageShapeView = createAction('feature/updateImageShapeView');

export const featureUpdateHeadingTitle = createAction('feature/updateHeadingTitle');
export const featureUpdateHeadingDescription = createAction('feature/updateHeadingDescription');
export const featureUpdateHeadingTextAlign = createAction('feature/updateHeadingTextAlign');
export const featureUpdateHeadingImage = createAction('feature/updateHeadingImage');
export const featureUpdateHeadingDivider = createAction('feature/updateHeadingDivider');

export const featureUpdateSectionIsBackground = createAction('feature/updateSectionIsBackground');
export const featureUpdateSectionTextColor = createAction('feature/updateSectionTextColor');
export const featureUpdateSectionBackgroundColor = createAction('feature/updateSectionBackgroundColor');
export const featureUpdateSectionOpacity = createAction('feature/updateSectionOpacity');
export const featureUpdateSectionIsFullWidth = createAction('feature/updateSectionIsFullWidth');
export const featureUpdateSectionShadow = createAction('feature/updateSectionShadow');
export const featureUpdateSectionShadowColor = createAction('feature/updateSectionShadowColor');
export const featureUpdateSectionPadding = createAction('feature/updateSectionPadding');
export const featureUpdateSectionMargin = createAction('feature/updateSectionMargin');
export const featureUpdateSectionBackgroundType = createAction('feature/updateSectionBackgroundType');
export const featureUpdateSectionBackgroundImage = createAction('feature/updateSectionBackgroundImage');
export const featureUpdateSectionGradientColor1 = createAction('feature/updateSectionGradientColor1');
export const featureUpdateSectionGradientColor2 = createAction('feature/updateSectionGradientColor2');
export const featureUpdateSectionGradientDirection = createAction('feature/updateSectionGradientDirection');
export const featureUpdateSectionGradientOffset = createAction('feature/updateSectionGradientOffset');
export const featureUpdateSectionBorder = createAction('feature/updateSectionBorder');
export const featureUpdateSectionBorderColor = createAction('feature/updateSectionBorderColor');
export const featureUpdateSectionShadowBorderColor = createAction('feature/updateSectionShadowBorderColor');
export const featureUpdateSectionShape = createAction('feature/updateSectionShape');

export const featureUpdateItemOpacity = createAction('feature/updateItemOpacity');
export const featureUpdateItemShadow = createAction('feature/updateItemShadow');
export const featureUpdateItemShadowColor = createAction('feature/updateItemShadowColor');
export const featureUpdateItemBorder = createAction('feature/updateItemBorder');
export const featureUpdateItemBorderColor = createAction('feature/updateItemBorderColor');
export const featureUpdateItemShape = createAction('feature/updateItemShape');
export const featureUpdateItemTextColor = createAction('feature/updateItemTextColor');
export const featureUpdateItemBackgroundColor = createAction('feature/updateItemBackgroundColor');
